import { delimiters, webInteractionTypes } from './constants';

export function titleCase(str) {
	const delimiterRegex = new RegExp(`(^|[${delimiters.join('\\')}])(\\w)`, 'g');
	return str?.replace(/'/g, "").replace(delimiterRegex,
		(_, delimiter, char) =>
			delimiter + char.toUpperCase());
}

export function clickActionArgs(name, controlType, locationInPage, URL = undefined, webInteractionType = webInteractionTypes.other) {
	const baseArgs = {
		web: {
			webInteraction: {
				name: titleCase(name),
				type: webInteractionType // Do not titleCase
			},
			_etassureco: {
				controlType
			}
		},
		siteKnowledge: {
			supportSiteSearch: {
				locationInPage
			}
		}
	};

	if (URL) {
		baseArgs.web.webInteraction.URL = URL;
	}

	return baseArgs;
}

export function pageViewArgs(name, siteSection, isHomePage = false, isErrorPage = false) {
	const searchParams = new URLSearchParams(location.search);
	const engagementId = (searchParams.get('engagementId') || searchParams.get('engagementid')) ?? undefined;

	let baseArgs = {
		web: {
			webPageDetails: {
				name,
				siteSection,
				isHomePage,
				isErrorPage
			}
		}
	};

	if (engagementId) {
		if (!baseArgs.web._etassureco) {
			baseArgs.web._etassureco = {engagementNumber: engagementId};
		}
	}

	return baseArgs;
}
